import Slider from './Slider';
import RadioButton from './RadioButton';
import setFontAwesome from './setFontAwesome';

export default class AppView {
    constructor(data) {
        this.data = data.items;
    }

    render() {
        setFontAwesome();
        const slider = new Slider(this.data);
        slider.render();
        const radioButton = new RadioButton();
        radioButton.render();
    }
}
